module.exports = __webpack_public_path__ + "img/sync_anim.8688bddf.gif";